import { dispatchOpenCommandPalette } from "@/lib/commandPaletteEvents"

import type { ShortcutAction } from "./KeyboardShortcutsContext"

const DEFAULT_SHORTCUTS: ShortcutAction[] = [
  {
    key: "⌘K",
    label: "Show menu",
    action: () => dispatchOpenCommandPalette("keyboard-shortcut"),
    state: {
      hiddenInPalette: true,
    },
  },
  {
    key: "/",
    label: "Search",
    action: () => dispatchOpenCommandPalette("keyboard-shortcut"),
    state: {
      paletteGroup: "other",
    },
  },
  {
    key: "?",
    label: "Show keyboard shortcuts",
    action: () => dispatchOpenCommandPalette("keyboard-help"),
    state: {
      paletteGroup: "other",
    },
  },
]

export const DEFAULT_SHORTCUTS_BY_KEY = new Map(
  DEFAULT_SHORTCUTS.map((shortcut) => [shortcut.key, shortcut]),
)
